import {useMutation} from "@apollo/client";
import {toast} from "react-hot-toast";

import {FormModal} from "@/components/form/overlay/FormModal.tsx";
import {
  GQL_IMPORT_SUBSCRIBERS,
  GQL_STATUS_PAGE_QUERY,
  GQL_SUBSCRIBERS,
  GQL_SUBSCRIBERS_COUNTS,
  ImportSubscribersResult,
} from "@/lib/queries/statuspages.ts";
import {ServerErrors} from "@/lib/types/common.ts";
import {
  ImportSubscribersForm,
  ImportSubscribersFormValues,
} from "@/pages/statuspages/tabs/subscribers/components/import-subscribers/ImportSubscribersForm.tsx";

interface ImportSubscribersModalProps {
  show: boolean;
  statusPageID: number;
  setShow: (show: boolean) => void;
}

export const ImportSubscribersModal = ({statusPageID, show, setShow}: ImportSubscribersModalProps) => {
  const [importSubscribers, {data, loading, reset}] = useMutation<ImportSubscribersResult>(GQL_IMPORT_SUBSCRIBERS, {
    refetchQueries: [GQL_SUBSCRIBERS_COUNTS, GQL_STATUS_PAGE_QUERY, GQL_SUBSCRIBERS],
  });

  const handleImport = async ({file}: ImportSubscribersFormValues) => {
    const response = await importSubscribers({
      variables: {
        statusPageID: statusPageID,
        file: file[0],
      },
    });

    setShow(!response?.data?.importSubscribers?.success);
    if (response?.data?.importSubscribers?.success) {
      toast.success("Subscribers successfully imported.");
    }
  };

  const handleClose = () => {
    reset();
    setShow(false);
  };

  const serverErrors = (data?.importSubscribers?.errors ? data?.importSubscribers?.errors : []) as ServerErrors;

  const formID = "import-subscribers";
  return (
    <FormModal
      size="lg"
      className="px-2"
      cancelBtnText="Cancel"
      submitBtnText="Import"
      title="Import Subscribers"
      show={show}
      formId={formID}
      disabled={loading}
      onCancel={handleClose}
      hasRequiredFields
    >
      <ImportSubscribersForm formID={formID} show={show} serverErrors={serverErrors} onSubmit={handleImport} />
    </FormModal>
  );
};
